import { render, staticRenderFns } from "./EditResourceModal.vue?vue&type=template&id=9b7de0a8&scoped=true"
import script from "./EditResourceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditResourceModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditResourceModal.vue?vue&type=style&index=0&id=9b7de0a8&prod&lang=scss&scoped=true"
import style1 from "./EditResourceModal.vue?vue&type=style&index=1&id=9b7de0a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7de0a8",
  null
  
)

export default component.exports